import { getDetectionState, getModelSlot, normalizeDetection } from './capabilities';

export const modelPlatforms = ['Intel', 'Raspberry Pi', 'Coral Dev Board', 'BrightSign'];
export const classifierTypes = { age: 'AGE', emotion: 'EMOTION', gender: 'GENDER', 'full-body-gender': 'GENDER_FULL', mtl: 'MTL' };

export const buildModelCatalog = response => {
  const entries = response.models || [];
  const types = [...new Set(entries.map(entry => entry.type))];
  return entries.map(entry => ({
    ...entry,
    model: { type: entry.type, version: entry.version, engine: entry.engine },
    platforms: entry.supportedPlatforms || []
  })).sort((a, b) => {
    const typeOrder = types.indexOf(a.type) - types.indexOf(b.type);
    if (typeOrder) return typeOrder;
    // Keep the plain TF and quantized TF variants at the bottom of their type.
    const tfOrder = Number(/\.tf(?:\.quant)?$/.test(a.version)) - Number(/\.tf(?:\.quant)?$/.test(b.version));
    return tfOrder || b.version.localeCompare(a.version, 'en', { numeric: true });
  });
};

export const filterModelCatalog = (catalog, platform) => catalog.filter(entry =>
  !platform || !entry.platforms.length || entry.platforms.includes(platform)
);

export const isDetectionModel = model => !!getModelSlot(model);
export const getDetectionMode = driver => {
  const state = getDetectionState(driver);
  return state.personIncluded || state.person ? 'face-person' : 'face';
};

// Update models and coupled flags atomically while retaining unrelated driver settings.
export const updateAudienceModels = (driver, models, detectionMode, selectedType) => {
  const config = { ...driver.config };
  if (selectedType === 'MTL') {
    models = models.filter(model => !['AGE', 'EMOTION', 'GENDER', 'AGE_GENDER'].includes(model.type));
  }
  if (['AGE', 'EMOTION', 'GENDER'].includes(selectedType)) {
    models = models.filter(model => model.type !== 'MTL');
  }
  models = normalizeDetection(models);
  const detection = getDetectionState({ models });
  config.enable_person_detection = !!(detection.personIncluded || detection.person);
  const hadFullBody = (driver.models || []).some(model => model.type === 'GENDER_FULL');
  const hasFullBody = models.some(model => model.type === 'GENDER_FULL');
  if (hadFullBody !== hasFullBody) config.full_body_gender = hasFullBody;
  if (selectedType === 'GENDER_FULL') config.full_body_gender = true;
  if (selectedType === 'GENDER') {
    config.full_body_gender = false;
    models = models.filter(model => model.type !== 'GENDER_FULL');
  }
  if (hasFullBody && config.full_body_gender !== false) {
    models = models.filter(model => model.type !== 'GENDER');
  }
  return { ...driver, models, config };
};
